import { useState, useEffect, useCallback, useRef } from 'react';
import { ref, onValue, update } from 'firebase/database';
import { database } from '../firebase';

const EMPTY_PROGRESS = {
  temas: {},
  examenFinal: null,
  certificate: false,
  updatedAt: Date.now(),
};

export const useCourseProgress = (courseId, uid) => {
  const [progress, setProgress] = useState(EMPTY_PROGRESS);
  const [loading, setLoading] = useState(true);
  const uidRef = useRef(uid);
  uidRef.current = uid;

  useEffect(() => {
    if (!courseId || !uidRef.current) {
      setProgress(EMPTY_PROGRESS);
      setLoading(false);
      return;
    }
    const progressRef = ref(database, `course_progress/${uidRef.current}/${courseId}`);
    const unsub = onValue(
      progressRef,
      (snap) => {
        setProgress({ ...EMPTY_PROGRESS, ...(snap.val() || {}) });
        setLoading(false);
      },
      (err) => {
        console.error('[CourseProgress] Error leyendo progreso:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [courseId]);

  const updateProgress = useCallback(
    (patch) => {
      if (!courseId || !uidRef.current) return;
      update(ref(database, `course_progress/${uidRef.current}/${courseId}`), {
        ...patch,
        updatedAt: Date.now(),
      }).catch((err) => console.error('[CourseProgress] Error guardando:', err));
    },
    [courseId]
  );

  return { progress, loading, updateProgress };
};

export const useAllCoursesProgress = (uid) => {
  const [progressMap, setProgressMap] = useState({});
  const [loading, setLoading] = useState(true);
  const uidRef = useRef(uid);
  uidRef.current = uid;

  useEffect(() => {
    if (!uidRef.current) {
      setProgressMap({});
      setLoading(false);
      return;
    }
    const allRef = ref(database, `course_progress/${uidRef.current}`);
    const unsub = onValue(
      allRef,
      (snap) => {
        setProgressMap(snap.val() || {});
        setLoading(false);
      },
      (err) => {
        console.error('[CourseProgress] Error leyendo progreso global:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return { progressMap, loading };
};
